import { Breadcrumb, Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Link, useLocation } from "react-router-dom";
import { Element, Link as LinkSection } from "react-scroll";
import { BigPlayButton, Player } from "video-react";

import CardText from "components/CardText";
import CarouselMulti from "components/CarouselMulti";
import DetailContact from "components/DetailContact";
import FadeInSection from "components/FadeInSection";
import LoadingSpin from "components/Loading";
import QuestBlog from "components/QuestBlog";
import ScrollUpBtn from "components/ScrollUpBtn";
import ViewSelect from "components/ViewSelect";
import YearSelect from "components/YearSelect";

import { contract, institute } from "core/schemas";
import {
  breadcrumbName,
  ListColor1,
  ListColor2,
  ListColorContact,
  ListColorQ,
  ListContact,
  ListView,
} from "core/util/common";
import { httpClient } from "core/util/httpClient";

import {
  BlockName,
  CardContact,
  Container,
  CustomCarousel,
  CusttomBreadcrumb,
  DetailBottom,
  DetailTop,
  FixBox,
  FixBoxLayout,
  HoverAni,
  Href,
  Line,
  NameCourse,
  SubBold,
  SubDetail,
  SubHead,
  SubTitle,
  TextName,
  Title,
  TitleEN,
  View,
} from "./dentistry.style";

import stuView from "assets/images/png/student_comp-01.png";

import learnIcon1 from "assets/images/svg/H09-1.svg";
import learnIcon2 from "assets/images/svg/H09-2.svg";

import titleSci1 from "assets/images/svg/title-sci-1.svg";
import titleSci2 from "assets/images/svg/title-sci-2.svg";
import titleSci3 from "assets/images/svg/title-sci-3.svg";

import titleSoct1 from "assets/images/svg/title-soct-1.svg";
import titleSoct2 from "assets/images/svg/title-soct-2.svg";
import titleSoct3 from "assets/images/svg/title-soct-3.svg";

import titleAgri1 from "assets/images/svg/title-agri-1.svg";
import titleAgri2 from "assets/images/svg/title-agri-2.svg";
import titleAgri3 from "assets/images/svg/title-agri-3.svg";

import titlePubh1 from "assets/images/svg/title-pubh-1.svg";
import titlePubh2 from "assets/images/svg/title-pubh-2.svg";
import titlePubh3 from "assets/images/svg/title-pubh-3.svg";

import titleMed1 from "assets/images/svg/title-med-1.svg";
import titleMed2 from "assets/images/svg/title-med-2.svg";
import titleMed3 from "assets/images/svg/title-med-3.svg";

import titleNurs1 from "assets/images/svg/title-nurs-1.svg";
import titleNurs2 from "assets/images/svg/title-nurs-2.svg";
import titleNurs3 from "assets/images/svg/title-nurs-3.svg";

import titleDigi1 from "assets/images/svg/title-digi-1.svg";
import titleDigi2 from "assets/images/svg/title-digi-2.svg";
import titleDigi3 from "assets/images/svg/title-digi-3.svg";

import titleEngi1 from "assets/images/svg/title-engi-1.svg";
import titleEngi2 from "assets/images/svg/title-engi-2.svg";
import titleEngi3 from "assets/images/svg/title-engi-3.svg";

import titleDent1 from "assets/images/svg/title-dent-1.svg";
import titleDent2 from "assets/images/svg/title-dent-2.svg";
import titleDent3 from "assets/images/svg/title-dent-3.svg";

import sci from "assets/images/png/01-Sci.png";
import soctech from "assets/images/png/02-Soctech.png";
import agri from "assets/images/png/03-Agri.png";
import engi from "assets/images/png/04-Engi.png";
import med from "assets/images/png/05-Med.png";
import nurs from "assets/images/png/06-Nurs.png";
import dent from "assets/images/png/07-Dent.png";
import pubH from "assets/images/png/08-PubH.png";
import digiT from "assets/images/png/09-DigiT.png";

import tech1 from "assets/images/jpg/dentistry-tech1.jpg";
import tech2 from "assets/images/jpg/dentistry-tech2.jpg";
import tech3 from "assets/images/jpg/dentistry-tech3.jpg";
import tech4 from "assets/images/jpg/dentistry-tech4.jpg";
import tech5 from "assets/images/jpg/dentistry-tech5.jpg";
import tech6 from "assets/images/jpg/dentistry-tech6.jpg";
import tech7 from "assets/images/jpg/dentistry-tech7.jpg";
import tech8 from "assets/images/jpg/dentistry-tech8.jpg";

import iconPDF from "assets/images/svg/icon-file-pdf.svg";

import paperIcon from "assets/images/svg/icon-paper.svg";
import videoIcon from "assets/images/svg/icon-video.svg";

function DentistryDepartment({ selectYear, year }) {
  const { pathname } = useLocation();
  const splitPath = pathname.split("/") || [];
  splitPath.shift();

  const [departmentData, setDepartmentData] = useState({});
  const [contactData, setContactData] = useState([]);
  const [slang, setSlang] = useState("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const styleDetailContact = { marginBottom: "5px" };
  const [isLoading, setIsLoading] = useState(false);
  const [view, setView] = useState({
    viewAll: 0,
    viewOfYear: 0,
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    getDataEnrollment();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const getView = async (year) => {
    const response = await httpClient.get(
      `${institute}?course=${splitPath[1]}&year=${year}`
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      setView({
        viewAll: data?.visitor,
        viewOfYear: data?.visitor_of_year,
      });
    } else {
      setView({ viewOfYear: 0, viewAll: 0 });
    }
  };

  const getDataEnrollment = async () => {
    setIsLoading(false);
    const response = await httpClient.get(
      `${institute}?course=${splitPath[1]}&year=${year}`,
      { incrementVisitor: true }
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      setIsLoading(true);
      setDepartmentData(data);
      setSlang(data?.slang);
      getDataContact(data?.id);
      setView({
        viewAll: data?.visitor,
        viewOfYear: data?.visitor_of_year,
      });
    } else {
      setIsLoading(true);
      setDepartmentData([]);
      setView({ viewOfYear: 0, viewAll: 0 });
    }
  };

  const getDataContact = async (id) => {
    const response = await httpClient.get(
      `${contract}?course=${id && id}&year=${year}`
    );

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setContactData(data);
    } else {
      setContactData([]);
    }
  };

  const newPath = (route) => {
    let path = "";
    const orderRoute = splitPath.indexOf(route);
    splitPath.map((item, i) => i <= orderRoute && (path += `/${item}`));
    return path;
  };

  const splitName = (text, position, detail) => {
    const word = text.split("\n");

    return <>{word[position]}</>;
  };

  const spliteLink = (link, text) => {
    const newLink = link.split(text);
    return (
      <div className="link-web">
        {text}
        <a href={`https://${newLink[1]}`} target="_blank" rel="noreferrer">
          <u>{newLink[1]}</u>
        </a>
      </div>
    );
  };

  const spliteYoutube = (link, text, icon) => {
    const newLink = link.split(text);
    return (
      <div
        className={`link-web dentistry ${
          icon && icon === "none" && "left-none"
        }`}
      >
        {icon && icon === "file" ? (
          <img
            src={paperIcon}
            alt="icon title"
            style={{ width: "32px" }}
            loading="lazy"
          />
        ) : (
          icon &&
          icon !== "none" && (
            <img
              src={videoIcon}
              alt="icon title"
              style={{ width: "32px" }}
              loading="lazy"
            />
          )
        )}
        {icon && icon === "file" && <br />}
        <a href={`${newLink[1]}`} target="_blank" rel="noreferrer">
          <u>{text}</u>
        </a>
      </div>
    );
  };

  const renderLink = (to, name) => {
    return (
      <LinkSection
        activeClass="active"
        to={to}
        spy={true}
        smooth={true}
        duration={500}
        offset={-130}
      >
        <HoverAni>
          <NameCourse height="105">{name}</NameCourse>
        </HoverAni>
      </LinkSection>
    );
  };

  const listImage1 = {
    "department-science": titleSci1,
    "department-social": titleSoct1,
    "department-agricultural": titleAgri1,
    "department-engineering": titleEngi1,
    "department-medicine": titleMed1,
    "department-nursing": titleNurs1,
    "department-dentistry": titleDent1,
    "department-public-health": titlePubh1,
    "department-degitech": titleDigi1,
  };

  const listImage2 = {
    "department-science": titleSci2,
    "department-social": titleSoct2,
    "department-agricultural": titleAgri2,
    "department-engineering": titleEngi2,
    "department-medicine": titleMed2,
    "department-nursing": titleNurs2,
    "department-dentistry": titleDent2,
    "department-public-health": titlePubh2,
    "department-degitech": titleDigi2,
  };

  const listImage3 = {
    "department-science": titleSci3,
    "department-social": titleSoct3,
    "department-agricultural": titleAgri3,
    "department-engineering": titleEngi3,
    "department-medicine": titleMed3,
    "department-nursing": titleNurs3,
    "department-dentistry": titleDent3,
    "department-public-health": titlePubh3,
    "department-degitech": titleDigi3,
  };

  const listImageContact = {
    "department-science": sci,
    "department-social": soctech,
    "department-agricultural": agri,
    "department-engineering": engi,
    "department-medicine": med,
    "department-nursing": nurs,
    "department-dentistry": dent,
    "department-public-health": pubH,
    "department-degitech": digiT,
  };

  return (
    <>
      <Container>
        <div className={`year-box ${slang}`}>
          <p>ข้อมูลประจำปี</p>
          <YearSelect onChange={selectYear && selectYear} year={year} />
        </div>
        {isLoading ? (
          <>
            <Row>
              <Col span={24}>
                <CusttomBreadcrumb>
                  {splitPath.map((item, i) => {
                    if (i !== splitPath.length - 1 && i !== 0) {
                      return (
                        <Breadcrumb.Item key={item}>
                          <Link to={newPath(item)}>{breadcrumbName[item]}</Link>
                        </Breadcrumb.Item>
                      );
                    } else {
                      return (
                        <Breadcrumb.Item key={item}>
                          <Link to={newPath(item)}>
                            {" "}
                            {breadcrumbName[item]}
                          </Link>
                        </Breadcrumb.Item>
                      );
                    }
                  })}
                </CusttomBreadcrumb>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Title className="animate__animated animate__slideInDown animate__slow">
                  {departmentData?.nameTH}
                </Title>
                <TitleEN className="animate__animated animate__flipInX animate__slow">
                  {departmentData?.nameEN}
                </TitleEN>
              </Col>
            </Row>

            {windowWidth <= 1280
              ? departmentData?.message && (
                  <Row className="row-title">
                    <Col span={12}>
                      <BlockName row={3}>
                        <img
                          loading="lazy"
                          src={listImage1[slang]}
                          alt="icon title"
                          style={{ maxWidth: "104px", width: "100%" }}
                        />

                        <TextName>
                          {splitName(departmentData?.message?.title, 0)}
                          <span>
                            {splitName(departmentData?.message?.title, 1, true)}
                          </span>
                        </TextName>
                      </BlockName>

                      <div className="col-image-profile">
                        <FadeInSection axis="y">
                          <img
                            loading="lazy"
                            src={
                              departmentData?.message?.image &&
                              departmentData?.message?.image[0]?.image_0
                            }
                            alt="dean"
                            style={{ marginTop: "20px", width: "100%" }}
                          />
                        </FadeInSection>
                      </div>

                      {departmentData?.message?.text &&
                        departmentData?.message?.text.map((item) => {
                          return (
                            <>
                              {item?.text_0 && (
                                <DetailTop>{item?.text_0}</DetailTop>
                              )}
                              {item?.text_1 && (
                                <DetailBottom>{item?.text_1}</DetailBottom>
                              )}
                              {item?.text_2 && (
                                <DetailBottom>{item?.text_2}</DetailBottom>
                              )}
                              {item?.text_3 && (
                                <DetailBottom>{item?.text_3}</DetailBottom>
                              )}
                            </>
                          );
                        })}
                    </Col>

                    {departmentData?.message?.image &&
                      departmentData?.message?.image.map((item) => {
                        return (
                          <>
                            <Col
                              span={11}
                              offset={1}
                              style={{
                                display: "flex",
                                alignItems: "baseline",
                              }}
                              className="col-image-profile"
                            ></Col>
                            {item?.image_1 && item?.image_2 && (
                              <Player
                                poster={item?.image_1}
                                className="img-people"
                                autoPlay
                                muted
                                playsInline
                                src={item?.image_2}
                              >
                                <BigPlayButton position="center" />
                              </Player>
                            )}
                          </>
                        );
                      })}
                  </Row>
                )
              : departmentData?.message && (
                  <Row className="row-title">
                    <Col span={12}>
                      <BlockName row={3}>
                        <img
                          loading="lazy"
                          src={listImage1[slang]}
                          alt="icon title"
                          style={{ width: "104px" }}
                        />

                        <TextName>
                          {splitName(departmentData?.message?.title, 0)}
                          <span>
                            {splitName(departmentData?.message?.title, 1, true)}
                          </span>
                        </TextName>
                      </BlockName>

                      {departmentData?.message?.text &&
                        departmentData?.message?.text.map((item) => {
                          return (
                            <>
                              {item?.text_0 && (
                                <DetailTop>{item?.text_0}</DetailTop>
                              )}
                              {item?.text_1 && (
                                <DetailBottom>{item?.text_1}</DetailBottom>
                              )}
                              {item?.text_2 && (
                                <DetailBottom>{item?.text_2}</DetailBottom>
                              )}
                              {item?.text_3 && (
                                <DetailBottom>{item?.text_3}</DetailBottom>
                              )}
                            </>
                          );
                        })}
                    </Col>

                    {departmentData?.message?.image &&
                      departmentData?.message?.image.map((item) => {
                        return (
                          <>
                            <Col
                              span={11}
                              offset={1}
                              style={{
                                display: "flex",
                                alignItems: "baseline",
                              }}
                              className="col-image-profile"
                            >
                              <FadeInSection axis="y">
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="dean"
                                  width={"100%"}
                                />
                              </FadeInSection>
                            </Col>
                            {item?.image_1 && item?.image_2 && (
                              <Player
                                poster={item?.image_1}
                                className="img-people"
                                autoPlay
                                muted
                                playsInline
                                src={item?.image_2}
                              >
                                <BigPlayButton position="center" />
                              </Player>
                            )}
                          </>
                        );
                      })}
                  </Row>
                )}

            {departmentData?.contract && (
              <Row>
                <Col span={24}>
                  <BlockName row={3}>
                    <img
                      loading="lazy"
                      src={listImage2[slang]}
                      alt="icon title"
                      style={{ width: "104px" }}
                    />
                    <TextName>
                      {departmentData?.contract[0]?.department}
                    </TextName>
                  </BlockName>

                  <Row className="row-name-course top" gutter={[24, 6]}>
                    {departmentData?.contract.slice(1).map((item, index) => {
                      return (
                        <Col span={8} key={index}>
                          <Href
                            to={item?.slang}
                            rel="noopener noreferrer"
                            target={"_self"}
                          >
                            <NameCourse>{item?.department}</NameCourse>
                          </Href>
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            )}

            {departmentData?.advice && (
              <Row>
                <Col span={24}>
                  <BlockName row={3}>
                    <img
                      loading="lazy"
                      src={listImage3[slang]}
                      alt="icon title"
                      style={{ width: "104px" }}
                    />
                    <TextName>{departmentData?.advice?.title}</TextName>
                  </BlockName>

                  <Row className="row-question" gutter={[24, 6]}>
                    {departmentData?.advice?.text &&
                      departmentData?.advice?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 ===
                              "เรียน มทส. อย่างไรให้จบตามเวลา ?" ||
                            item?.text_0 ===
                              "เรียนพยาบาล มทส. อย่างไรให้จบตามเวลา ?" ? (
                              <Col span={8}>
                                {renderLink(
                                  "เรียนอย่างไรให้จบตามเวลา ?",
                                  item?.text_0
                                )}
                              </Col>
                            ) : (
                              <Col span={8}>
                                {renderLink(item?.text_0, item?.text_0)}
                              </Col>
                            )}

                            {item?.text_1 ===
                              "เรียน มทส. อย่างไรให้จบตามเวลา ?" ||
                            item?.text_1 ===
                              "เรียนแพทย์อย่างไรให้จบตามเวลา ?" ? (
                              <Col span={8}>
                                {renderLink(
                                  "เรียนอย่างไรให้จบตามเวลา ?",
                                  item?.text_1
                                )}
                              </Col>
                            ) : (
                              <Col span={8}>
                                {renderLink(item?.text_1, item?.text_1)}
                              </Col>
                            )}

                            {item?.text_2 && (
                              <Col span={8}>
                                {renderLink(item?.text_2, item?.text_2)}
                              </Col>
                            )}

                            {item?.text_3 && (
                              <Col span={8}>
                                {renderLink(item?.text_3, item?.text_3)}
                              </Col>
                            )}
                            {item?.text_4 && (
                              <Col span={8}>
                                {renderLink(item?.text_4, item?.text_4)}
                              </Col>
                            )}
                            {item?.text_5 && (
                              <Col span={8}>
                                {renderLink(item?.text_5, item?.text_5)}
                              </Col>
                            )}
                            {item?.text_6 && (
                              <Col span={8}>
                                {renderLink(item?.text_6, item?.text_6)}
                              </Col>
                            )}
                            {item?.text_7 && (
                              <Col span={8}>
                                {renderLink(item?.text_7, item?.text_7)}
                              </Col>
                            )}
                            {item?.text_8 && (
                              <Col span={8}>
                                {renderLink(item?.text_8, item?.text_8)}
                              </Col>
                            )}
                            {item?.text_9 && (
                              <Col span={8}>
                                {renderLink(item?.text_9, item?.text_9)}
                              </Col>
                            )}
                            {item?.text_10 && (
                              <Col span={8}>
                                {renderLink(item?.text_10, item?.text_10)}
                              </Col>
                            )}
                            {item?.text_11 && (
                              <Col span={8}>
                                {renderLink(item?.text_11, item?.text_11)}
                              </Col>
                            )}
                            {item?.text_12 && (
                              <Col span={8}>
                                {renderLink(item?.text_12, item?.text_12)}
                              </Col>
                            )}
                            {item?.text_13 && (
                              <Col span={8}>
                                {renderLink(item?.text_13, item?.text_13)}
                              </Col>
                            )}
                            {item?.text_14 && (
                              <Col span={8}>
                                {renderLink(item?.text_14, item?.text_14)}
                              </Col>
                            )}
                            {item?.text_15 && (
                              <Col span={8}>
                                {renderLink(item?.text_15, item?.text_15)}
                              </Col>
                            )}
                            {item?.text_16 && (
                              <Col span={8}>
                                {renderLink(item?.text_16, item?.text_16)}
                              </Col>
                            )}
                            {item?.text_17 && (
                              <Col span={8}>
                                {renderLink(item?.text_17, item?.text_17)}
                              </Col>
                            )}
                            {item?.text_18 && (
                              <Col span={8}>
                                {renderLink(item?.text_18, item?.text_18)}
                              </Col>
                            )}
                            {item?.text_19 && (
                              <Col span={8}>
                                {renderLink(item?.text_19, item?.text_19)}
                              </Col>
                            )}
                            {item?.text_20 && (
                              <Col span={8}>
                                {renderLink(item?.text_20, item?.text_20)}
                              </Col>
                            )}
                          </>
                        );
                      })}
                  </Row>
                </Col>
              </Row>
            )}

            {departmentData?.regulations && (
              <Element name={departmentData?.regulations?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col span={12}>
                      <SubTitle align="center" bottom="0">
                        {departmentData?.regulations?.title}
                      </SubTitle>
                      {departmentData?.regulations?.text &&
                        departmentData?.regulations?.text[0]?.text_0 && (
                          <SubDetail align="center" top="0" bottom="0">
                            {departmentData?.regulations?.text[0]?.text_0}
                          </SubDetail>
                        )}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "10px",
                        }}
                      >
                        <a
                          href="https://sutgateway.sut.ac.th/ces/rules/rules2/DENT2.pdf"
                          target="_blank"
                          rel="noreferrer"
                          download
                        >
                          <SubDetail top="0">
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <img
                                loading="lazy"
                                src={iconPDF}
                                alt="icon file pdf"
                                style={{
                                  width: "28px",
                                  height: "28px",
                                  marginRight: "10px",
                                }}
                              />
                              <u>ดูเอกสาร</u>
                            </div>
                          </SubDetail>
                        </a>
                      </div>
                    </Col>
                    <Col span={12}>
                      <Element name={departmentData?.pay?.title}>
                        <SubTitle align="center" bottom="0">
                          {departmentData?.pay?.title}
                        </SubTitle>
                        {departmentData?.pay?.text &&
                          departmentData?.pay?.text[0]?.text_0 && (
                            <SubDetail align="center" top="0" bottom="0">
                              {departmentData?.pay?.text[0]?.text_0}
                            </SubDetail>
                          )}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "10px",
                          }}
                        >
                          <a
                            href="http://sutgateway.sut.ac.th/admissions2021/ces/fee/B68.pdf"
                            target="_blank"
                            rel="noreferrer"
                            download
                          >
                            <SubDetail top="0">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  loading="lazy"
                                  src={iconPDF}
                                  alt="icon file pdf"
                                  style={{
                                    width: "28px",
                                    height: "28px",
                                    marginRight: "10px",
                                  }}
                                />
                                <u>ดูเอกสาร</u>
                              </div>
                            </SubDetail>
                          </a>
                        </div>
                      </Element>
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData?.pros && (
              <Element name={departmentData?.pros?.title}>
                <SubTitle top="50">{departmentData?.pros?.title}</SubTitle>
                {departmentData?.pros?.text.map((item) => {
                  return (
                    <>
                      <Row gutter={24} className="row-detail-card">
                        <Col span={8}>
                          <FadeInSection axis="y">
                            <img
                              loading="lazy"
                              src={
                                departmentData?.pros?.image &&
                                departmentData?.pros?.image[0]?.image_0
                              }
                              alt="pros icon"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                                margin: "20px 0",
                              }}
                            />
                          </FadeInSection>
                          <SubHead>{item?.text_0}</SubHead>
                          {item?.text_1 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_1}
                            </SubDetail>
                          )}
                        </Col>
                        <Col span={8}>
                          <FadeInSection axis="y">
                            <img
                              loading="lazy"
                              src={
                                departmentData?.pros?.image &&
                                departmentData?.pros?.image[0]?.image_1
                              }
                              alt="pros icon"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                                margin: "20px 0",
                              }}
                            />
                          </FadeInSection>
                          <SubHead>{item?.text_2}</SubHead>
                          {item?.text_3 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_3}
                            </SubDetail>
                          )}
                        </Col>
                        <Col span={8}>
                          <FadeInSection axis="y">
                            <img
                              loading="lazy"
                              src={
                                departmentData?.pros?.image &&
                                departmentData?.pros?.image[0]?.image_2
                              }
                              alt="pros icon"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                                margin: "20px 0",
                              }}
                            />
                          </FadeInSection>
                          <SubHead>{item?.text_4}</SubHead>
                          {item?.text_5 && (
                            <SubDetail top="0" bottom="0" indent="35">
                              {item?.text_5}
                            </SubDetail>
                          )}
                        </Col>
                      </Row>
                    </>
                  );
                })}
              </Element>
            )}

            {departmentData?.q1 && (
              <Element name={departmentData?.q1?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <SubTitle align="center" top="50" bottom="0">
                    {departmentData?.q1?.title}
                  </SubTitle>
                  <SubDetail align="center" top="0" bottom="0">
                    เน้นการเรียนรู้แบบ Active learning
                  </SubDetail>
                  <Row gutter={24} className="row-detail-card">
                    <Col span={8}>
                      <FadeInSection axis="y">
                        <Player
                          poster={
                            "/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y1-crop.png#t=35"
                          }
                          className="img-people"
                          muted
                          playsInline
                          src={
                            "/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y1.mp4#t=35"
                          }
                        >
                          <BigPlayButton position="center" />
                        </Player>
                      </FadeInSection>
                      <SubHead left="0" bottom="0">
                        ชั้นปีที่ 1
                      </SubHead>
                      <SubDetail left="0" top="0" bottom="0">
                        เรียนในกลุ่มรายวิชาศึกษาทั่วไป และวิทยาศาสตร์พื้นฐาน
                      </SubDetail>
                    </Col>
                    <Col span={8}>
                      <FadeInSection axis="y">
                        <Player
                          poster={
                            "/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y2-crop.png#t=35"
                          }
                          className="img-people"
                          muted
                          playsInline
                          src={
                            "/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y2.mp4#t=35"
                          }
                        >
                          <BigPlayButton position="center" />
                        </Player>
                        <Player
                          poster={
                            "/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y3-crop.png#t=35"
                          }
                          className="img-people"
                          muted
                          playsInline
                          src={
                            "/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y3.mp4#t=35"
                          }
                        >
                          <BigPlayButton position="center" />
                        </Player>
                      </FadeInSection>
                      <SubHead left="0" bottom="0">
                        ชั้นปีที่ 2-3
                      </SubHead>
                      <SubDetail left="0" top="0" bottom="0">
                        เรียนรายวิชาด้านวิทยาศาสตร์การแพทย์
                        (ระบบการทำงานของอวัยวะภายในร่างกาย
                        ที่เกี่ยวข้องกับงานทันตกรรม) และวิชาชีพทันตแพทย์พื้นฐาน
                        (สุขภาพช่องปากครอบครัวและชุมชน
                        สุขภาพช่องปากของบุคคลวัยต่าง ๆ ทักษะทางคลินิกทันตกรรม
                        ฯลฯ)
                      </SubDetail>
                    </Col>
                    <Col span={8}>
                      <FadeInSection axis="y">
                        <Player
                          poster={
                            "/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20%e0%b9%80%e0%b8%9b%e0%b8%b4%e0%b8%94%e0%b8%ab%e0%b9%89%e0%b8%ad%e0%b8%87%e0%b9%81%e0%b8%a5%e0%b8%9b%e0%b8%97%e0%b8%b1%e0%b8%99%e0%b8%95%e0%b9%81%e0%b8%9e%e0%b8%97%e0%b8%a2%e0%b9%8c%20%e0%b8%a1%e0%b8%97%e0%b8%aa.-crop.png#t=35"
                          }
                          className="img-people"
                          muted
                          playsInline
                          src={
                            "/service-sut/image/image-2023/department-dentistry/VDO/lab.mp4#t=35"
                          }
                        >
                          <BigPlayButton position="center" />
                        </Player>
                        <Player
                          poster={
                            "/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y4-crop.png#t=35"
                          }
                          className="img-people"
                          muted
                          playsInline
                          src={
                            "/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y4.mp4#t=35"
                          }
                        >
                          <BigPlayButton position="center" />
                        </Player>
                      </FadeInSection>
                      <SubHead left="0" bottom="0">
                        ชั้นปีที่ 4
                      </SubHead>
                      <SubDetail left="0" top="0" bottom="0">
                        เรียนวิชาเฉพาะด้านวิชาชีพทันตแพทย์
                        ทั้งภาคทฤษฎีและฝึกทักษะในห้องปฏิบัติการ
                      </SubDetail>
                    </Col>
                  </Row>
                  <Row gutter={24} className="row-detail-card">
                    <Col span={8}>
                      <FadeInSection axis="y">
                        <Player
                          poster={
                            "/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y5-crop.png#t=35"
                          }
                          className="img-people"
                          muted
                          playsInline
                          src={
                            "/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y5.mp4#t=35"
                          }
                        >
                          <BigPlayButton position="center" />
                        </Player>
                      </FadeInSection>
                      <SubHead left="0" bottom="0">
                        ชั้นปีที่ 5
                      </SubHead>
                      <SubDetail left="0" top="0" bottom="0">
                        เรียนวิชาเฉพาะทางด้านวิชาชีพทันตแพทย์
                        และฝึกปฏิบัติงานคลินิกหมุนเวียนระหว่างศูนย์สุขภาพช่องปาก
                        รพ.มทส. และในโรงพยาบาลแหล่งฝึก (รพ.มหาราชนครราชสีมา
                        รพ.ชัยภูมิ รพ.บุรีรัมย์ รพ.สุรินทร์ และ
                        รพ.ภูเขียวเฉลิมพระเกียรติ)
                      </SubDetail>
                    </Col>
                    <Col span={8}>
                      <FadeInSection axis="y">
                        <Player
                          poster={
                            "/service-sut/image/image-2023/department-dentistry/VDO/Screenshot%20DENT%20SUT%20Y6-crop.png"
                          }
                          className="img-people"
                          muted
                          playsInline
                          src={
                            "/service-sut/image/image-2023/department-dentistry/VDO/DENT%20SUT%20Y6.mp4"
                          }
                        >
                          <BigPlayButton position="center" />
                        </Player>
                      </FadeInSection>
                      <SubHead left="0" bottom="0">
                        ชั้นปีที่ 6
                      </SubHead>
                      <SubDetail left="0" top="0" bottom="0">
                        ฝึกประสบการณ์ด้านคลินิก
                        และฝึกปฏิบัติงานในสถานพยาบาลระดับต่าง ๆ
                        เพื่อเรียนรู้ระบบการทำงานในสถานที่จริง
                        รวมถึงเรียนรู้เกี่ยวกับนวัตกรรมวิทยาการสุขภาพช่องปาก
                        และโครงการวิจัย
                      </SubDetail>
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData?.q2 && (
              <Element name={departmentData?.q2?.title}>
                <SubTitle top="50" align="center" bottom="0">
                  {departmentData?.q2?.title}
                </SubTitle>
                <FixBoxLayout>
                  <FadeInSection axis="y">
                    <CarouselMulti
                      image1={
                        departmentData?.q2?.image &&
                        departmentData?.q2?.image[0]?.image_0
                          ? departmentData?.q2?.image[0]?.image_0
                          : rectangle1
                      }
                      image2={
                        departmentData?.q2?.image &&
                        departmentData?.q2?.image[0]?.image_1
                          ? departmentData?.q2?.image[0]?.image_1
                          : rectangle1
                      }
                      image3={
                        departmentData?.q2?.image &&
                        departmentData?.q2?.image[0]?.image_2
                          ? departmentData?.q2?.image[0]?.image_2
                          : rectangle1
                      }
                      image4={
                        departmentData?.q2?.image &&
                        departmentData?.q2?.image[0]?.image_3
                          ? departmentData?.q2?.image[0]?.image_3
                          : rectangle1
                      }
                      image5={
                        departmentData?.q2?.image &&
                        departmentData?.q2?.image[0]?.image_4
                          ? departmentData?.q2?.image[0]?.image_4
                          : rectangle1
                      }
                      image6={
                        departmentData?.q2?.image &&
                        departmentData?.q2?.image[0]?.image_5
                          ? departmentData?.q2?.image[0]?.image_5
                          : rectangle1
                      }
                      image7={
                        departmentData?.q2?.image &&
                        departmentData?.q2?.image[0]?.image_6
                          ? departmentData?.q2?.image[0]?.image_6
                          : rectangle1
                      }
                      image8={
                        departmentData?.q2?.image &&
                        departmentData?.q2?.image[0]?.image_7
                          ? departmentData?.q2?.image[0]?.image_7
                          : rectangle1
                      }
                    />
                  </FadeInSection>
                </FixBoxLayout>

                <Row className="row-group">
                  <Col span={12}>
                    {departmentData?.q2?.text[0]?.text_0 && (
                      <SubDetail top="0" align="center">
                        {spliteYoutube(
                          departmentData?.q2?.text[0]?.text_0,
                          "ห้องปฏิบัติการพัฒนาทักษะทางคลินิกสุขภาพช่องปาก DENT SUT ",
                          true
                        )}
                      </SubDetail>
                    )}
                  </Col>
                  <Col span={12}>
                    {departmentData?.q2?.text[0]?.text_1 && (
                      <SubDetail top="0" align="center">
                        {spliteYoutube(
                          departmentData?.q2?.text[0]?.text_1,
                          "OHC Fun Fun ",
                          true
                        )}
                      </SubDetail>
                    )}
                  </Col>
                </Row>
              </Element>
            )}

            {departmentData?.q3 && departmentData?.q4 && (
              <Element name={departmentData?.q3?.title}>
                <Element name={departmentData?.q4?.title}>
                  <FixBox bg={ListColor2[slang]}>
                    <Row gutter={24} className="row-group">
                      <Col span={11}>
                        <SubTitle>{departmentData?.q3?.title}</SubTitle>
                        {departmentData?.q3?.text &&
                          departmentData?.q3?.text[0] && (
                            <SubDetail indent="32">
                              {departmentData?.q3?.text[0]?.text_0}
                            </SubDetail>
                          )}
                      </Col>
                      <Col span={12} offset={1}>
                        <Element name={departmentData?.q4?.title}>
                          <SubTitle>{departmentData?.q4?.title}</SubTitle>
                        </Element>
                        {departmentData?.q4?.text &&
                          departmentData?.q4?.text[0] && (
                            <>
                              {departmentData?.q4?.text[0]?.text_0 && (
                                <SubDetail indent="32" bottom="0">
                                  {departmentData?.q4?.text[0]?.text_0}
                                </SubDetail>
                              )}

                              {departmentData?.q4?.text[0]?.text_1 && (
                                <SubDetail indent="32" top="0">
                                  {departmentData?.q4?.text[0]?.text_1}
                                </SubDetail>
                              )}
                            </>
                          )}
                      </Col>
                    </Row>
                  </FixBox>
                </Element>
              </Element>
            )}

            {departmentData?.result && (
              <Element name={departmentData?.result?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={12}>
                    <SubTitle>{departmentData?.result?.title}</SubTitle>
                    <SubHead className="bg-circle" bottom="0">
                      {departmentData?.result?.text[0]?.text_0}
                    </SubHead>
                    <SubDetail className="bg-circle" bottom="0" top="10">
                      <img
                        loading="lazy"
                        src={learnIcon1}
                        alt="icon circle"
                        style={{
                          zIndex: "-1",
                          position: "absolute",
                          left: "-50px",
                          top: "-20px",
                          width: "133px",
                        }}
                      />
                      {departmentData?.result?.text[0]?.text_1}
                    </SubDetail>

                    {(departmentData?.result?.text[0]?.text_2 ||
                      departmentData?.result?.text[0]?.text_3) && (
                      <SubDetail bottom="0" top="0">
                        {departmentData?.result?.text[0]?.text_2 &&
                          departmentData?.result?.text[0]?.text_2}
                        <br />
                        {departmentData?.result?.text[0]?.text_3 &&
                          departmentData?.result?.text[0]?.text_3}
                      </SubDetail>
                    )}

                    <SubDetail className="bg-circle" bottom="0">
                      <img loading="lazy" src={learnIcon2} alt="icon circle" />
                      {departmentData?.result?.text[0]?.text_4}
                    </SubDetail>

                    {departmentData?.result?.text[0]?.text_5 && (
                      <SubDetail top="0">
                        {departmentData?.result?.text[0]?.text_5}
                      </SubDetail>
                    )}

                    <SubHead bottom="0">
                      {departmentData?.result?.text[0]?.text_6}
                    </SubHead>

                    <SubDetail top="10" bottom="0">
                      {departmentData?.result?.text[0]?.text_7}
                    </SubDetail>
                    <SubDetail top="0" bottom="0">
                      {departmentData?.result?.text[0]?.text_8}
                    </SubDetail>
                    <SubDetail top="0" bottom="0">
                      {departmentData?.result?.text[0]?.text_9}
                    </SubDetail>
                    <SubDetail top="0" bottom="0">
                      {departmentData?.result?.text[0]?.text_10}
                    </SubDetail>
                    <SubDetail top="0" bottom="0">
                      {departmentData?.result?.text[0]?.text_11}
                    </SubDetail>
                    <SubDetail top="0">
                      {departmentData?.result?.text[0]?.text_12}
                    </SubDetail>
                  </Col>
                  <Col span={11} offset={1}>
                    <FadeInSection axis="x">
                      <CustomCarousel autoplay bg={ListColor1[slang]}>
                        {departmentData?.result?.image &&
                          departmentData?.result?.image[0]?.image_0 && (
                            <img
                              loading="lazy"
                              src={departmentData?.result?.image[0]?.image_0}
                              alt="icon group"
                              style={{
                                borderRadius: "20px",
                                width: "100%",
                              }}
                            />
                          )}
                        {departmentData?.result?.image &&
                          departmentData?.result?.image[0]?.image_1 && (
                            <img
                              loading="lazy"
                              src={departmentData?.result?.image[0]?.image_1}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                        {departmentData?.result?.image &&
                          departmentData?.result?.image[0]?.image_2 && (
                            <img
                              loading="lazy"
                              src={departmentData?.result?.image[0]?.image_2}
                              alt="icon group"
                              style={{ borderRadius: "20px", width: "100%" }}
                            />
                          )}
                      </CustomCarousel>
                    </FadeInSection>
                  </Col>
                </Row>
              </Element>
            )}

            {departmentData?.q5 && (
              <Element name={departmentData?.q5?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col span={12}>
                      {departmentData?.q5?.image ? (
                        departmentData?.q5?.image.map((item) => {
                          return (
                            <FadeInSection axis="y">
                              <CustomCarousel autoplay bg={ListColor1[slang]}>
                                {item?.image_0 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_0}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_1 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_1}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_2 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_2}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                              </CustomCarousel>
                            </FadeInSection>
                          );
                        })
                      ) : (
                        <img
                          loading="lazy"
                          src={engineer}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}
                    </Col>
                    <Col span={11} offset={1}>
                      <SubTitle>{departmentData?.q5?.title}</SubTitle>
                      {departmentData?.q5?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 && (
                              <SubDetail bottom="0" indent="32">
                                {item?.text_0}
                              </SubDetail>
                            )}
                            {item?.text_1 && (
                              <SubDetail top="0" indent="32">
                                {item?.text_1}
                              </SubDetail>
                            )}

                            {item?.text_2 && <SubHead>{item?.text_2}</SubHead>}
                            {item?.text_3 && (
                              <SubDetail bottom="0" indent="32">
                                {spliteLink(item?.text_3, "1) Log in: ")}
                              </SubDetail>
                            )}
                            {item?.text_4 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_4}
                              </SubDetail>
                            )}
                            {item?.text_5 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_5}
                              </SubDetail>
                            )}
                            {item?.text_6 && (
                              <SubDetail top="0" indent="32">
                                {item?.text_6}
                              </SubDetail>
                            )}
                          </>
                        );
                      })}
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData?.q6 && (
              <Element name={departmentData?.q6?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={11}>
                    <SubTitle>{departmentData?.q6?.title}</SubTitle>
                    {departmentData?.q6?.text.map((item) => {
                      return (
                        <>
                          {item?.text_0 && (
                            <SubDetail bottom="0" indent="32">
                              {item?.text_0}
                            </SubDetail>
                          )}
                          {item?.text_1 && (
                            <SubDetail top="0" bottom="0" indent="32">
                              {item?.text_1}
                            </SubDetail>
                          )}

                          {item?.text_2 && (
                            <SubDetail top="0" bottom="2" indent="35">
                              {item?.text_2 && item?.text_2}
                            </SubDetail>
                          )}

                          {item?.text_3 && (
                            <SubDetail top="0" bottom="0" indent="20">
                              {spliteYoutube(
                                item?.text_3,
                                "รีวิวมทส. หอพักหญิงมทส. ห้องแอร์ ",
                                true
                              )}
                            </SubDetail>
                          )}
                          {item?.text_4 && (
                            <SubDetail top="0" bottom="0" indent="20">
                              {spliteYoutube(
                                item?.text_4,
                                "Live in SUT EP.08 : เป็นเด็กหอ มทส. ต้องเจอสิ่งนี้!! ",
                                true
                              )}
                            </SubDetail>
                          )}
                        </>
                      );
                    })}
                  </Col>

                  <Col span={12} offset={1}>
                    {departmentData?.q6?.image ? (
                      departmentData?.q6?.image.map((item) => {
                        return (
                          <FadeInSection axis="x">
                            <CustomCarousel autoplay bg={ListColor1[slang]}>
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })
                    ) : (
                      <img
                        loading="lazy"
                        src={engineer1}
                        alt="icon group"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    )}
                  </Col>
                </Row>
              </Element>
            )}

            {departmentData?.q7 && (
              <Element name={departmentData?.q7?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <SubTitle top="50">{departmentData?.q7?.title}</SubTitle>
                  <Row className="row-col-3">
                    <Col span={8}>
                      {departmentData?.q7?.text[0]?.text_0 && (
                        <SubDetail top="0" bottom="0" indent="20">
                          {spliteYoutube(
                            departmentData?.q7?.text[0]?.text_0,
                            "ข้อบังคับมหาวิทยาลัยเทคโนโลยีสุรนารี ว่าด้วย เครื่องแต่งกายนักศึกษามหาวิทยาลัยเทคโนโลยีสุรนารี พ.ศ. 2545 ",
                            "file"
                          )}
                        </SubDetail>
                      )}
                    </Col>
                    <Col span={8}>
                      {departmentData?.q7?.text[0]?.text_1 && (
                        <SubDetail top="0" bottom="0" indent="20">
                          {spliteYoutube(
                            departmentData?.q7?.text[0]?.text_1,
                            "แนวปฏิบัติการแต่งกายนักศึกษาทันตแพทย์ชั้นคลินิก ",
                            "file"
                          )}
                        </SubDetail>
                      )}
                    </Col>
                    <Col span={8}>
                      {departmentData?.q7?.text[0]?.text_2 && (
                        <SubDetail top="0" bottom="0" indent="20">
                          {spliteYoutube(
                            departmentData?.q7?.text[0]?.text_2,
                            "ระเบียบการแต่งกายนักศึกษา คลินิกการเรียนการสอน แหล่งฝึกศูนย์สุขภาพช่องปาก โรงพยาบาลมหาวิทยาลัยเทคโนโลยีสุรนารี ",
                            "file"
                          )}
                        </SubDetail>
                      )}
                    </Col>
                  </Row>
                  <Row
                    gutter={24}
                    className="row-col-3"
                    style={{ marginTop: "32px" }}
                  >
                    <Col span={8}>
                      {departmentData?.q7?.text[0].text_3 && (
                        <NameCourse left="0" bottom="0">
                          {departmentData?.q7?.text[0].text_3}
                        </NameCourse>
                      )}

                      <FadeInSection axis="x">
                        <img
                          loading="lazy"
                          src={
                            "/service-sut/image/2023/department-dentistry/10/%e0%b8%9e%e0%b8%b4%e0%b8%98%e0%b8%b5%e0%b8%81%e0%b8%b2%e0%b8%a31.png"
                          }
                          alt="icon group"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                            margin: "20px 0",
                          }}
                        />
                      </FadeInSection>
                    </Col>
                    <Col span={8}>
                      {departmentData?.q7?.text[0].text_4 && (
                        <NameCourse left="0" bottom="0">
                          {departmentData?.q7?.text[0].text_4}
                        </NameCourse>
                      )}

                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          <img
                            loading="lazy"
                            src={
                              "/service-sut/image/2023/department-dentistry/10/%e0%b8%9e%e0%b8%b4%e0%b8%98%e0%b8%b5%e0%b8%81%e0%b8%b2%e0%b8%a32.png"
                            }
                            alt="icon group"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                              margin: "20px 0",
                            }}
                          />
                          <img
                            loading="lazy"
                            src={
                              "/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%8a%e0%b8%b1%e0%b9%89%e0%b8%99%e0%b8%9b%e0%b8%a3%e0%b8%b5%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%811.png"
                            }
                            alt="icon group"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                              margin: "20px 0",
                            }}
                          />
                          <img
                            loading="lazy"
                            src={
                              "/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%8a%e0%b8%b1%e0%b9%89%e0%b8%99%e0%b8%9b%e0%b8%a3%e0%b8%b5%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%812.png"
                            }
                            alt="icon group"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                              margin: "20px 0",
                            }}
                          />
                          <img
                            loading="lazy"
                            src={
                              "/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%8a%e0%b8%b1%e0%b9%89%e0%b8%99%e0%b8%9b%e0%b8%a3%e0%b8%b5%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%813.png"
                            }
                            alt="icon group"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                              margin: "20px 0",
                            }}
                          />
                        </CustomCarousel>
                      </FadeInSection>
                    </Col>

                    <Col span={8}>
                      {departmentData?.q7?.text[0].text_5 && (
                        <NameCourse left="0" bottom="0">
                          {departmentData?.q7?.text[0].text_5}
                        </NameCourse>
                      )}

                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          <img
                            loading="lazy"
                            src={
                              "/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%8a%e0%b8%b1%e0%b9%89%e0%b8%99%e0%b8%9b%e0%b8%a3%e0%b8%b5%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%814.png"
                            }
                            alt="icon group"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                              margin: "20px 0",
                            }}
                          />
                          <img
                            loading="lazy"
                            src={
                              "/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%811.png"
                            }
                            alt="icon group"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                              margin: "20px 0",
                            }}
                          />
                          <img
                            loading="lazy"
                            src={
                              "/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%812.png"
                            }
                            alt="icon group"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                              margin: "20px 0",
                            }}
                          />
                        </CustomCarousel>
                      </FadeInSection>
                    </Col>
                  </Row>

                  <Row
                    gutter={24}
                    className="row-col-3"
                    style={{
                      marginTop: "32px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Col span={8}>
                      {departmentData?.q7?.text[0].text_6 && (
                        <NameCourse left="0" bottom="0">
                          {departmentData?.q7?.text[0].text_6}
                        </NameCourse>
                      )}

                      <FadeInSection axis="x">
                        <CustomCarousel autoplay bg={ListColor1[slang]}>
                          <img
                            loading="lazy"
                            src={
                              "/service-sut/image/2023/department-dentistry/10/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2-%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%813.png"
                            }
                            alt="icon group"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                              margin: "20px 0",
                            }}
                          />
                          <img
                            loading="lazy"
                            src={
                              "/service-sut/image/image-2023/department-dentistry/10/%e0%b8%9b%e0%b8%8f%e0%b8%b4%e0%b8%9a%e0%b8%b1%e0%b8%95%e0%b8%b4%e0%b8%81%e0%b8%b2%e0%b8%a3%20%e0%b8%9b%e0%b8%a3%e0%b8%b51.png"
                            }
                            alt="icon group"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                              margin: "20px 0",
                            }}
                          />
                          <img
                            loading="lazy"
                            src={
                              "/service-sut/image/image-2023/department-dentistry/10/%e0%b8%9b%e0%b8%8f%e0%b8%b4%e0%b8%9a%e0%b8%b1%e0%b8%95%e0%b8%b4%e0%b8%81%e0%b8%b2%e0%b8%a3%20%e0%b8%9b%e0%b8%a3%e0%b8%b52.png"
                            }
                            alt="icon group"
                            style={{
                              borderRadius: "20px",
                              width: "100%",
                              margin: "20px 0",
                            }}
                          />
                        </CustomCarousel>
                      </FadeInSection>
                    </Col>

                    <Col span={8}>
                      {departmentData?.q7?.text[0].text_7 && (
                        <NameCourse left="0" bottom="0">
                          {departmentData?.q7?.text[0].text_7}
                        </NameCourse>
                      )}

                      <FadeInSection axis="x">
                        <img
                          loading="lazy"
                          src={
                            "/service-sut/image/image-2023/department-dentistry/10/%e0%b8%9b%e0%b8%8f%e0%b8%b4%e0%b8%9a%e0%b8%b1%e0%b8%95%e0%b8%b4%e0%b8%84%e0%b8%a5%e0%b8%b4%e0%b8%99%e0%b8%b4%e0%b8%81%201.png"
                          }
                          alt="icon group"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                            margin: "20px 0",
                          }}
                        />
                      </FadeInSection>
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData?.q8 && (
              <Element name={departmentData?.q8?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={11}>
                    <SubTitle>{departmentData?.q8?.title}</SubTitle>
                    {departmentData?.q8?.text.map((item) => {
                      return (
                        <>
                          <SubDetail indent="35">
                            {item?.text_0 && item?.text_0} <br />
                          </SubDetail>
                          <SubDetail indent="35">
                            {item?.text_1 && item?.text_1}
                          </SubDetail>
                        </>
                      );
                    })}
                  </Col>

                  <Col span={12} offset={1}>
                    {departmentData?.q8?.image ? (
                      departmentData?.q8?.image.map((item) => {
                        return (
                          <FadeInSection axis="x">
                            <CustomCarousel autoplay bg={ListColor1[slang]}>
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })
                    ) : (
                      <img
                        loading="lazy"
                        src={engineer1}
                        alt="icon group"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    )}
                  </Col>
                </Row>
              </Element>
            )}

            {departmentData?.teacher && (
              <Element name={departmentData?.teacher?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <Row gutter={24} className="row-group">
                    <Col span={12}>
                      {departmentData?.teacher?.image ? (
                        departmentData?.teacher?.image.map((item) => {
                          return (
                            <FadeInSection axis="x">
                              <CustomCarousel autoplay bg={ListColor1[slang]}>
                                {item?.image_0 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_0}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_1 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_1}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                                {item?.image_2 && (
                                  <img
                                    loading="lazy"
                                    src={item?.image_2}
                                    alt="icon group"
                                    style={{
                                      borderRadius: "20px",
                                      width: "100%",
                                    }}
                                  />
                                )}
                              </CustomCarousel>
                            </FadeInSection>
                          );
                        })
                      ) : (
                        <img
                          loading="lazy"
                          src={engineer1}
                          alt="icon group"
                          style={{ borderRadius: "20px", width: "100%" }}
                        />
                      )}
                    </Col>
                    <Col span={11} offset={1}>
                      <SubTitle>{departmentData?.teacher?.title}</SubTitle>
                      {departmentData?.teacher?.text.map((item) => {
                        return (
                          <>
                            {item?.text_0 && (
                              <SubDetail bottom="0" indent="32">
                                {item?.text_0}
                              </SubDetail>
                            )}
                            {item?.text_1 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_1}
                              </SubDetail>
                            )}
                            {item?.text_2 && (
                              <SubDetail top="0" bottom="0" indent="32">
                                {item?.text_2}
                              </SubDetail>
                            )}
                            {item?.text_3 && (
                              <SubDetail top="0" indent="32">
                                {item?.text_3}
                              </SubDetail>
                            )}

                            {item?.text_4 && <SubHead>{item?.text_4}</SubHead>}
                            {item?.text_5 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_5}
                              </SubDetail>
                            )}
                            {item?.text_6 && (
                              <SubDetail top="0" bottom="0">
                                {item?.text_6}
                              </SubDetail>
                            )}
                            {item?.text_7 && (
                              <SubDetail top="0">{item?.text_7}</SubDetail>
                            )}
                          </>
                        );
                      })}
                    </Col>
                  </Row>
                </FixBox>
              </Element>
            )}

            {departmentData?.q10 && departmentData?.q11 && (
              <Element name={departmentData?.q10?.title}>
                <Row gutter={24} className="row-group">
                  <Col span={11}>
                    <SubTitle>{departmentData?.q10?.title}</SubTitle>
                    {departmentData?.q10?.text &&
                      departmentData?.q10?.text[0] && (
                        <SubDetail>
                          {departmentData?.q10?.text[0]?.text_0} <br />
                          {departmentData?.q10?.text[0]?.text_1} <br />
                          {departmentData?.q10?.text[0]?.text_2} <br />
                          {departmentData?.q10?.text[0]?.text_3}
                        </SubDetail>
                      )}
                    <Element name={departmentData?.q11?.title}>
                      <SubTitle>{departmentData?.q11?.title}</SubTitle>
                    </Element>
                    {departmentData?.q11?.text &&
                      departmentData?.q11?.text[0] && (
                        <SubDetail>
                          {departmentData?.q11?.text[0]?.text_0}
                          <br />
                          {departmentData?.q11?.text[0]?.text_1}
                          <br />
                          {departmentData?.q11?.text[0]?.text_2}
                          <br />
                          {departmentData?.q11?.text[0]?.text_3}
                        </SubDetail>
                      )}
                  </Col>
                  <Col span={12} offset={1}>
                    {departmentData?.q9?.image ? (
                      departmentData?.q9?.image.map((item) => {
                        return (
                          <FadeInSection axis="y">
                            <CustomCarousel autoplay bg={ListColor1[slang]}>
                              {item?.image_0 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_0}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_1 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_1}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                              {item?.image_2 && (
                                <img
                                  loading="lazy"
                                  src={item?.image_2}
                                  alt="icon group"
                                  style={{
                                    borderRadius: "20px",
                                    width: "100%",
                                  }}
                                />
                              )}
                            </CustomCarousel>
                          </FadeInSection>
                        );
                      })
                    ) : (
                      <img
                        loading="lazy"
                        src={engineer1}
                        alt="icon group"
                        style={{ borderRadius: "20px", width: "100%" }}
                      />
                    )}
                  </Col>
                </Row>
              </Element>
            )}

            {departmentData?.question && (
              <Element name={departmentData?.question?.title}>
                <FixBox bg={ListColor2[slang]}>
                  <SubTitle>{departmentData?.question?.title}</SubTitle>

                  {departmentData?.question?.type &&
                    departmentData?.question?.type.length >= 0 &&
                    departmentData?.question?.type.map((item, index, row) => {
                      return (
                        <div key={`title-${index}`}>
                          <Row className="row-top">
                            <Col span={24}>
                              {item?.title && (
                                <TextHead>{item?.title}</TextHead>
                              )}
                            </Col>
                            <Col span={24}>
                              {item?.question.length >= 0 &&
                                item?.question.map((item, index) => {
                                  return (
                                    <QuestBlog
                                      colorQuest={ListColorQ[slang]}
                                      top="40"
                                      key={`quest-${index}`}
                                      headText={item?.question}
                                      ansTextFirst={
                                        item?.answers ? item?.answers : ""
                                      }
                                      ansTextSecon={
                                        item?.answer_1 ? item?.answer_1 : ""
                                      }
                                      ansTextThird={
                                        item?.answer_2 ? item?.answer_2 : ""
                                      }
                                    />
                                  );
                                })}
                            </Col>
                          </Row>
                          {index + 1 !== row.length && (
                            <div className="line-style">
                              <Line />
                            </div>
                          )}
                        </div>
                      );
                    })}

                  <SubDetail align="center">
                    <div className="link-web">
                      <a
                        href="https://docs.google.com/forms/d/e/1FAIpQLSeqIE5oMjijiR7NHhtuytZ7oKcuvVZGvIGCbW1reqk8dw_QwQ/viewform"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <u>
                          ช่องทางรับฟังความคิดเห็น/ รับเรื่องร้องเรียน/
                          ถาม-ตอบ(Q&A)
                        </u>
                      </a>
                    </div>
                  </SubDetail>
                  <div style={{ width: "100%", display: "flex" }}>
                    <Line />
                  </div>
                </FixBox>
              </Element>
            )}

            <Element name="8 เทคนิคเรียนทันตแพทย์ยังไงให้ปัง !!!">
              <FixBoxLayout>
                <SubTitle align="center" className="title-tech">
                  8 เทคนิคเรียนทันตแพทย์ยังไงให้ปัง !!!
                </SubTitle>
                <FadeInSection axis="y">
                  <CarouselMulti
                    image1={tech1}
                    image2={tech2}
                    image3={tech3}
                    image4={tech4}
                    image5={tech5}
                    image6={tech6}
                    image7={tech7}
                    image8={tech8}
                  />
                </FadeInSection>
              </FixBoxLayout>
            </Element>

            {departmentData?.should_contact && (
              <Element name="เรื่องนี้ต้องติดต่อใคร">
                <SubTitle align="center" className="title-tech">
                  เรื่องนี้ต้องติดต่อใคร
                </SubTitle>
                <SubBold align="center">ภายในสำนักวิชาทันตแพทยศาสตร์</SubBold>
                <Row className="row-name-course" gutter={[24, 24]}>
                  {departmentData?.should_contact && (
                    <>
                      {departmentData?.should_contact[0] && (
                        <Col span={8}>
                          <FadeInSection axis="y">
                            <CardText
                              colorText="#774f9f"
                              image={departmentData?.should_contact[0]?.image}
                              title={departmentData?.should_contact[0]?.title}
                              detail={departmentData?.should_contact[0]?.detail}
                              link={departmentData?.should_contact[0]?.link_1}
                            />
                          </FadeInSection>
                        </Col>
                      )}
                      {departmentData?.should_contact[1] && (
                        <Col span={8}>
                          <FadeInSection axis="y">
                            <CardText
                              colorText="#774f9f"
                              image={departmentData?.should_contact[1]?.image}
                              title={departmentData?.should_contact[1]?.title}
                              detail={departmentData?.should_contact[1]?.detail}
                              link={departmentData?.should_contact[1]?.link_1}
                            />
                          </FadeInSection>
                        </Col>
                      )}
                      {departmentData?.should_contact[2] && (
                        <Col span={8}>
                          <FadeInSection axis="y">
                            <CardText
                              colorText="#774f9f"
                              image={departmentData?.should_contact[2]?.image}
                              title={departmentData?.should_contact[2]?.title}
                              detail={departmentData?.should_contact[2]?.detail}
                              link={departmentData?.should_contact[2]?.link_1}
                            />
                          </FadeInSection>
                        </Col>
                      )}
                    </>
                  )}
                </Row>

                <SubBold align="center" top="20">
                  ภายในมหาวิทยาลัย
                </SubBold>
                <Row className="row-name-course" gutter={[24, 24]}>
                  {departmentData?.should_contact && (
                    <>
                      {departmentData?.should_contact[3] && (
                        <Col span={8}>
                          <FadeInSection axis="x">
                            <CardText
                              colorText="#774f9f"
                              image={departmentData?.should_contact[3]?.image}
                              title={departmentData?.should_contact[3]?.title}
                              detail={departmentData?.should_contact[3]?.detail}
                              link={departmentData?.should_contact[3]?.link_1}
                            />
                          </FadeInSection>
                        </Col>
                      )}
                      {departmentData?.should_contact[4] && (
                        <Col span={8}>
                          <FadeInSection axis="x">
                            <CardText
                              colorText="#774f9f"
                              image={departmentData?.should_contact[4]?.image}
                              title={departmentData?.should_contact[4]?.title}
                              detail={departmentData?.should_contact[4]?.detail}
                              link={departmentData?.should_contact[4]?.link_1}
                            />
                          </FadeInSection>
                        </Col>
                      )}
                      {departmentData?.should_contact[5] && (
                        <Col span={8}>
                          <FadeInSection axis="x">
                            <CardText
                              colorText="#774f9f"
                              image={departmentData?.should_contact[5]?.image}
                              title={departmentData?.should_contact[5]?.title}
                              detail={departmentData?.should_contact[5]?.detail}
                              link1={departmentData?.should_contact[5]?.link_1}
                              link2={departmentData?.should_contact[5]?.link_2}
                              link3={departmentData?.should_contact[5]?.link_3}
                            />
                          </FadeInSection>
                        </Col>
                      )}
                    </>
                  )}
                </Row>
              </Element>
            )}

            {contactData && (
              <>
                <SubTitle top="60" align="center">
                  {ListContact[slang]}
                </SubTitle>
                <Row
                  gutter={24}
                  style={{ marginTop: "50px" }}
                  className="row-contact"
                >
                  <Col span={8}>
                    <CardContact background={ListColorContact[slang]}>
                      <div className="container">
                        <DetailContact
                          color={`${"white"}`}
                          title={contactData[0]?.title}
                          phone={contactData[0]?.phone_1}
                          office={contactData[0]?.phone_2}
                          facebook={contactData[0]?.fb}
                          website={contactData[0]?.site}
                          email1={contactData[0]?.email_1}
                          email2={contactData[0]?.email_2}
                          email3={contactData[0]?.email_3}
                          line={contactData[0]?.line}
                          indent="40"
                          type="department"
                        />
                      </div>

                      {contactData && (
                        <img
                          loading="lazy"
                          src={
                            contactData[0]?.image
                              ? contactData[0]?.image
                              : listImageContact[slang]
                          }
                          alt="icon rectangle"
                          style={{
                            borderRadius: "20px",
                            width: "100%",
                            marginTop: "20px",
                          }}
                        />
                      )}
                    </CardContact>
                  </Col>

                  <Col span={15} offset={1}>
                    <Row gutter={24}>
                      {contactData.length > 1
                        ? contactData.slice(1).map((item, index) => {
                            return (
                              <Col
                                span={12}
                                style={{ padding: "10px" }}
                                key={index}
                              >
                                <div style={styleDetailContact}>
                                  <DetailContact
                                    color="var(--black)"
                                    title={item?.title}
                                    phone={item?.phone_1}
                                    office={item?.phone_2}
                                    facebook={item?.fb}
                                    website={item?.site}
                                    email1={item?.email_1}
                                    email2={item?.email_2}
                                    email3={item?.email_3}
                                    line={item?.line}
                                    indent={"0"}
                                    slang={slang}
                                    type="branch"
                                  />
                                </div>
                              </Col>
                            );
                          })
                        : contactData[0]?.address !== "" && (
                            <Col span={12} style={{ padding: "10px" }}>
                              <DetailContact
                                color="var(--black)"
                                title={contactData[0]?.title}
                                address={contactData[0]?.address}
                                slang={slang}
                                type="branch"
                              />
                            </Col>
                          )}
                    </Row>
                  </Col>
                </Row>
              </>
            )}

            <FixBoxLayout bg={ListColor2[slang]}>
              <div className="layout-view">
                <Row className="row-group" style={{ alignItems: "center" }}>
                  <Col span={6}>
                    <img
                      loading="lazy"
                      src={stuView}
                      style={{ width: "100%", maxWidth: "460px" }}
                      alt="student view"
                    />
                  </Col>
                  <Col offset={1} span={17}>
                    <div style={{ maxwWidth: "450px" }}>
                      <SubHead align="center">{ListView[slang]}</SubHead>
                      <Row className="row-view">
                        <Col span={12}>
                          <SubHead>ตั้งแต่เริ่มเปิดเว็บไซต์</SubHead>
                          <View>
                            <CountUp
                              start={0}
                              end={view.viewAll ? view?.viewAll : 0}
                              duration={2}
                              useEasing={true}
                              useGrouping={true}
                              separator=","
                              decimals={0}
                              decimal=","
                            />
                          </View>
                          <SubHead>ครั้ง</SubHead>
                        </Col>
                        <Col span={12}>
                          <div
                            style={{
                              display: "flex",
                              gap: "20px",
                            }}
                          >
                            <SubHead>ปี (พ.ศ.)</SubHead>
                            <ViewSelect
                              year={year}
                              background="#EA8B49"
                              onChange={(value) => getView(value)}
                            />
                          </div>
                          <View>
                            <CountUp
                              start={0}
                              end={view?.viewOfYear ? view?.viewOfYear : 0}
                              duration={2}
                              useEasing={true}
                              useGrouping={true}
                              separator=","
                              decimals={0}
                              decimal=","
                            />
                          </View>
                          <SubHead>ครั้ง</SubHead>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </FixBoxLayout>
          </>
        ) : (
          <LoadingSpin />
        )}
      </Container>
      <ScrollUpBtn />
    </>
  );
}

export default DentistryDepartment;
